<template>
  <div class="white">
    <v-timeline>
      <v-timeline-item v-for="(order, index) of orders" :key="index">
        <v-card-title>{{ order.name }}</v-card-title>
        <v-card-subtitle>
          <div>
            {{
              order.expiration_date
                ? `Expiration: ${order.expiration_date}`
                : "Does Not Expire"
            }}
          </div>
          <div>Frequency: {{ getFrequencyString(order) }}</div>
        </v-card-subtitle>
        <v-card-text>
          {{ order.description ? `Instructions: ${order.description}` : "" }}
        </v-card-text>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  props: {
    orders: Array,
  },
  methods: {
    getFrequencyString(order) {
      if (order.frequency && !(order.freq_count || order.freq_period)) {
        return order.frequency;
      }
      const count = parseInt(order.freq_count, 10);
      const period = parseInt(order.freq_period, 10);
      if (count === 1) {
        return `Once every ${this.pluralize("day", period)}`;
      }
      return `${count} times every ${this.pluralize("day", period)}`;
    },
    pluralize(word, count) {
      return `${count !== 1 ? `${count} ` : ""}${word}${
        count !== 1 ? "s" : ""
      }`;
    },
  },
};
</script>

<style></style>
